/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionSortieStatus
 */
export interface InputUavMissionSortieStatus {
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionSortieStatus
     */
    status: InputUavMissionSortieStatusStatusEnum;
}


/**
 * @export
 */
export const InputUavMissionSortieStatusStatusEnum = {
    Airborne: 'airborne',
    BeyondContactLine: 'beyond_contact_line',
    Lost: 'lost',
    Landed: 'landed'
} as const;
export type InputUavMissionSortieStatusStatusEnum = typeof InputUavMissionSortieStatusStatusEnum[keyof typeof InputUavMissionSortieStatusStatusEnum];


/**
 * Check if a given object implements the InputUavMissionSortieStatus interface.
 */
export function instanceOfInputUavMissionSortieStatus(value: object): boolean {
    if (!('status' in value)) return false;
    return true;
}

export function InputUavMissionSortieStatusFromJSON(json: any): InputUavMissionSortieStatus {
    return InputUavMissionSortieStatusFromJSONTyped(json, false);
}

export function InputUavMissionSortieStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionSortieStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function InputUavMissionSortieStatusToJSON(value?: InputUavMissionSortieStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
    };
}

